import WizardCard from "../../components/WizardCard"
import OrderedList from "../../components/OrderedList"
import CaptionList from "../../components/CaptionList"
import useMediaQuery from "../../hooks/useMediaQuery"
import IMG from "../../images/gov-introduction-what-you-get.png"

const GovtIntroductionWhatYouGetCard = () => {
  const isMaxWidthSm = useMediaQuery("(max-width: 664px)")

  return (
    <WizardCard paddingSize={isMaxWidthSm ? "sm" : "lg-y"}>
      <div className="flex flex-col gap-6">
        <h2 className="text-2xl font-display font-medium leading-[124%] tracking-[0.48px]">
          What you'll get
        </h2>

        <OrderedList
          list={[
            "Three practice stack options based on your goal(s) and eligibility.",
            "PDF Document that includes information that will speed up your application time, including eligibility details for your application and recommended practice stacks.",
            "Step-by-step plan to help guide you in getting your land practice approved and implemented",
          ]}
          itemClass="font-body text-sm !leading-[140%] !tracking-[0.28px] !mb-3 last:!mb-0"
          centered
        />

        <figure>
          <img
            src={IMG}
            alt="What you'll get"
            className="block w-full h-auto"
          />
        </figure>

        <div className="bg-sand border-l-2 border-l-[#ECA674] rounded-r-sm p-4">
          <CaptionList
            caption="What this isn't"
            list={[
              "Our recommendation is not the only choice you have when you are planning what's best to do for your land. You can choose other options if you think they are better.",
              "We do not apply for you. You must go through the agency yourself.",
              "We do not prepare all your documents. At the end, we will provide you an action plan that lists all docs and questions you will need for your NRCS meeting.",
            ]}
            itemClass="font-body text-charcoal-500 !text-xs !leading-[140%] !tracking-[0.36px]"
            size="xs"
          />
        </div>
      </div>
    </WizardCard>
  )
}

export default GovtIntroductionWhatYouGetCard
